export default __webpack_public_path__ + "static/media/editor-toolbar-icon-italic.6dd89879.svg";